if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        // Ensure loading-text stays hidden during add to cart
        // CSS has !important rules that show loading-text when .submit class is present
        // So we need to use !important to override it
        const loadingText = this.submitButton.querySelector(".loading-text");
        if (loadingText) {
          loadingText.classList.add("hidden");
          loadingText.style.setProperty("display", "none", "important");
          loadingText.style.setProperty("visibility", "hidden", "important");
        }
        
        // Add submit class - CSS will try to show loading-text, but we'll override it
        this.submitButton.classList.add("submit");
        
        // Re-apply hiding styles immediately after class is added to override CSS
        // Use setTimeout to ensure it happens after browser applies CSS
        setTimeout(() => {
          if (loadingText) {
            loadingText.style.setProperty("display", "none", "important");
            loadingText.style.setProperty("visibility", "hidden", "important");
          }
        }, 0);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        
        // Check if this is a pre-order
        const variantId = formData.get("id");
        const variantSelects = document.querySelector("variant-selects, variant-radios");
        let isPreOrder = false;
        
        if (variantSelects && variantSelects.currentVariant) {
          const currentVariant = variantSelects.currentVariant;
          const inventoryQuantity = currentVariant.inventory_quantity || 0;
          const inventoryPolicy = currentVariant.inventory_policy || "";
          const continueSellWhenOutOfStock = inventoryPolicy.includes("continue");
          const showPreOrder =
            currentVariant.metafields?.show_preorder === "true" ||
            currentVariant.metafields?.show_preorder === true;
          
          // Pre-order requires: showPreOrder = true, inventory < 1, AND continueSellWhenOutOfStock = true
          isPreOrder = showPreOrder && inventoryQuantity < 1 && continueSellWhenOutOfStock;
          
          if (isPreOrder) {
            console.log("📦 Pre-order detected, adding _is_preorder property");
            formData.append("properties[_is_preorder]", "true");
          }
        }
        
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        this.submitButton.setAttribute("aria-disabled", true);
        // Keep main button text visible - don't hide it, just show the spinner
        // Only hide it if we need to show something else
        const mainButtonText = this.submitButton.querySelector('span:not(.loading-text)');
        // We'll keep the main button text visible during the loading state
        // The spinner will be visible, and the text will stay visible too

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              const mainButtonText = this.submitButton.querySelector('span:not(.loading-text)');
              if (mainButtonText) {
                mainButtonText.classList.add('hidden');
              }
              // Ensure loading-text stays hidden
              if (loadingText) {
                loadingText.classList.add('hidden');
                loadingText.style.setProperty("display", "none", "important");
                loadingText.style.setProperty("visibility", "hidden", "important");
              }
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { 
                  this.cart.renderContents(response);
                  // Open native cart drawer
                  if (this.cart && typeof this.cart.open === 'function') {
                    this.cart.open();
                  }
                });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              // Open native cart drawer
              if (this.cart && typeof this.cart.open === 'function') {
                this.cart.open();
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.classList.remove('submit'); // Remove submit class to prevent CSS from showing loading-text
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            
            // Ensure loading-text stays hidden after completion
            const loadingTextFinal = this.submitButton.querySelector(".loading-text");
            if (loadingTextFinal) {
              loadingTextFinal.classList.add("hidden");
              loadingTextFinal.style.setProperty("display", "none", "important");
              loadingTextFinal.style.setProperty("visibility", "hidden", "important");
            }
            
            // Restore main button text (Add to Cart)
            const mainButtonTextFinal = this.submitButton.querySelector('span:not(.loading-text)');
            if (mainButtonTextFinal && !this.error) {
              mainButtonTextFinal.classList.remove("hidden");
              mainButtonTextFinal.style.setProperty("display", "inline-block", "important");
              mainButtonTextFinal.style.setProperty("visibility", "visible", "important");
            }
          });

        // Rebuy event listener removed - using native cart
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // Rebuy-related methods removed - using native cart
    }
  );
}

(function activeSize() {
  let btnsWrapper = document.querySelectorAll(".product-detail__size-nav");

  btnsWrapper.forEach(function (element) {
    let btnSizes = element.querySelectorAll(".btn_size");

    for (let btn of btnSizes) {
      btn.addEventListener("click", function (e) {
        if (!this.classList.contains("active-detail")) {
          clearActives(btnSizes);
          this.classList.add("active-detail");
        }
      });
    }

    function clearActives(elements) {
      if (elements) {
        for (let classEl of elements) {
          classEl.classList.remove("active-detail");
        }
      }
    }
  });
})();

(function selectMob() {
  let selectWrapper = document.querySelectorAll(".size-dropdown");
  selectWrapper.forEach(function (element) {
    let selectBtn = element.querySelector(".select_btn");
    let sizeNav = element.querySelector(".size_nav");
    let btnSizes = element.querySelectorAll(".btn_size");

    selectBtn.addEventListener("click", addStyles);

    function addStyles() {
      if (!this.matches(".product-detail__size-select-btn-active")) {
        document.querySelectorAll(".select_btn").forEach((el) => {
          el.classList.remove("product-detail__size-select-btn-active");
        });
        document.querySelectorAll(".size_nav").forEach((el) => {
          el.classList.remove("active-show");
        });
      }
      sizeNav.classList.toggle("active-show");
      selectBtn.classList.toggle("product-detail__size-select-btn-active");
    }

    for (let btn of btnSizes) {
      btn.addEventListener("click", () => {
        selectBtn.innerHTML = btn.textContent;
        sizeNav.classList.toggle("active-show");
        selectBtn.classList.toggle("product-detail__size-select-btn-active");
      });
    }
  });
})();

function closeTabs() {
  document.querySelectorAll(".select_btn").forEach((el) => {
    el.classList.remove("product-detail__size-select-btn-active");
  });

  document.querySelectorAll(".size_nav").forEach((el) => {
    el.classList.remove("active-show");
  });
}

document.addEventListener("click", function handleClick(e) {
  const selectBtnCheck = e.target.classList.contains("select_btn");
  if (!selectBtnCheck) {
    closeTabs();
  }
});
